import '../css/StatusBar.css';


export default function StatusBar({ status, setStatus }) {
    
    const types = ['wishlist', 'applied', 'interviewing', 'offer']
    return (
        <div className='status-bar'>
            {types.map(type => (
                <label key={type} className='status-type'>
                    <input
                        type='radio'
                        name='status'
                        value={type}
                        checked={type===status}
                        onChange={()=>setStatus(type)}
                    />
                    <span>{type}</span>
                </label>
            ))}
        </div>
    )
}
